import {GET_USER_ACTION, GET_PERMISSION, GET_LIST_SERVICE} from "../actions/actionTypes";

import { updateObject } from "../utility";

const initialState = {
  error: null,
  loading: false,
  user: null,
  // userPermission: null
  permission: null,
  lsService:{}
};

const getUser = (state, action) => {
  return updateObject(state, {
    user:action.payload
  });
};

const getPermission = (state, action) => {
  return updateObject(state, {
    permission:action.payload
  });
};

const getListService = (state, action) => {
  return updateObject(state, {
    lsService:action.payload
  });
};


const reducer = (state = initialState, action) => {
  // console.log('action',action);
  switch (action.type) {
    case GET_USER_ACTION:
        return getUser(state, action);
    case GET_PERMISSION:
      return getPermission(state, action);
    case GET_LIST_SERVICE:
      return getListService(state, action);
    default:
      return state;
  }
};

export default reducer;
